import { RefObject } from 'react';

export const scrollToRef = (ref: RefObject<HTMLDivElement>) =>
    window.scrollTo({ top: ref.current.offsetTop, left: 0, behavior: 'smooth' });
